import script from "./AppsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsPage.vue?vue&type=script&setup=true&lang=js"

import "./AppsPage.vue?vue&type=style&index=0&id=03eedbea&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03eedbea"]])

export default __exports__